import React, { useState } from "react";
import axios from "axios";
import assets from "../../../../../assets/assets";
import styled from "styled-components";
import Rankings from "./Rankings";
import SelectSecondaryGenres from "./SelectSecondaryGenres";
import SelectPrimaryGenre from "./SelectPrimaryGenre";
import {
  IconController,
  ImgController,
  LottieController,
} from "../../../../Scripts/ImgController";
import { apiURL } from "../../../../Config/url";
import { useAxiosConfigGlobal } from "../../../../Config/axios";
import Ripples from "react-ripples";
import HttpConfirmation from "../../HttpConfirmation";
import {
  mobileBottomSheet,
  mobileOverlay,
} from "../../../../Scripts/mobileBottomSheet";
const Wrapper = styled.div`
  .name-input {
    border: 1px solid black;
  }
  .bio-input {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 8px;
    width: 100%;
  }
  .bio-input::-webkit-scrollbar {
    display: none;
  }
  .ranking-dropdown {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 4px;
    width: 200px;
    cursor: pointer;
  }
  .name-input {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 6px 8px;
    font-size: 16px;
    color: #6b7280;
    width: fit-content;
  }
  .genre-dropdown {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 12px;
    cursor: pointer;
    width: fit-content;
  }
  .input-wrapper {
    width: 75%;
  }
  .genres {
    background: #9ba5b7;
    color: white;
    padding: 4px 6px;
    display: flex;
    flex-direction: row;
    border-radius: 16px;
    gap: 8px;
    cursor: pointer;
  }
  .modal-ranking {
    width: 250px;
    background: #ffffff;
    border: 1px solid #f3f4f6;
    box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1),
      0px 10px 10px -5px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
  }
  .modal-genre {
    width: 320px;
    background: #ffffff;
    border: 1px solid #f3f4f6;
    box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1),
      0px 10px 10px -5px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
  }
  .active {
    color: #0061ff;
    border-bottom: 3px solid #0061ff;
  }
  .border-CK {
    border-bottom: 1px solid #e5e7eb;
  }
  .input {
    border: 1px solid#d1d5db;
    border-radius: 8px;
    width: 100%;
    margin-top: 16px;
    height: 36px;
    padding: 10px 4px 10px 32px;
  }
  .checkbox {
    width: 20px;
    height: 20px;
  }
  .result-list::-webkit-scrollbar {
    width: 0 !important;
    display: none !important;
  }
  .checkbox-unchecked {
    width: 20px;
    height: 20px;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    cursor: pointer;
  }
  .checkbox-unchecked:hover {
    width: 20px;
    height: 20px;
    border: 1px solid #93c5fd;
    border-radius: 4px;
    background: #dbeafe;
  }
  textarea {
    resize: none;
  }
  @media (max-width: 767px) {
    .input-wrapper {
      width: 100%;
    }
    .ranking-dropdown {
      width: 100%;
    }
    .name-input {
      width: 100%;
    }
  }
`;
const Overlay = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 102 !important;
  top: 0;
  left: 0;
  ${mobileOverlay}
`;
const PopupRanking = styled.div`
  position: absolute;
  top: 34px;
  z-index: 103 !important;
  ${mobileBottomSheet(".modal-ranking")}
`;
const PopupGenre = styled.div`
  position: absolute;
  top: 54px;
  z-index: 103 !important;
  ${mobileBottomSheet(".modal-genre")}
  .hover-effect {
    cursor: pointer;
  }
  .hover-effect:hover {
    background: linear-gradient(
      270deg,
      rgba(0, 97, 255, 0.45) 0%,
      rgba(0, 97, 255, 0) 100%
    );
  }
  .hover-effect .activeshde {
    font-weight: 700;
    color: #0061ff !important;
  }
`;

const ArtistCard = ({
  data,
  genres,
  SGFirst,
  setCKPopup,
  setCKPopupType,
  setCKPopupMessage,
  isUserCanEdit,
  oneRingRulesAll,
}) => {
  const CurrentPublisher = JSON.parse(
    localStorage.getItem("Current-Publisher")
  );
  const axiosConfig = useAxiosConfigGlobal();
  const [editable, setEditable] = useState(false);
  const [dummy, setDummy] = useState(false);
  const [mailAttributes, setMailAttributes] = useState([]);
  const [selectedRank, setSelectedRank] = useState(data.profile.ranking);
  const [primaryGenre, setPrimaryGenre] = useState(data.primary_genre);
  const [secondaryGenres, setSecondaryGenres] = useState(data.secondary_genres);
  const [rankingPopup, setRankingPopup] = useState(false);
  const [secondaryGenresPopup, setSecondaryGenresPopup] = useState(false);
  const [primaryGenrePopup, setPrimaryGenrePopup] = useState(false);

  const [requestSent, setRequestSent] = useState(false);
  const [rankingChanged, setRankingChanged] = useState(false);
  const [nameChanged, setNameChanged] = useState(false);
  const [genreChanged, setGenreChanged] = useState(false);
  const [bioChanged, setBioChanged] = useState(false);

  const [nameField, setNameField] = useState("");
  const [bioField, setBioField] = useState("");
  const [confirmation, setConfirmation] = useState(false);
  const mailData = {
    model: {
      id: data.id,
      type: "artist",
    },
    requested: CurrentPublisher.email,
    current_publisher: {
      name: data.name,
      cover: data.cover,
    },
    attributes: mailAttributes,
  };
  const requestHandler = () => {
    setRequestSent(true);

    axios
      .post(apiURL + "notifications/panel/emails", mailData, axiosConfig)
      .then((res) => {
        if (res.status === 200) {
          setEditable(false);
          mailAttributes.length = 0;
          setCKPopupType("Success");
          setCKPopupMessage("changeRequestSuccess");
          setCKPopup(true);
          setRequestSent(false);
          setNameChanged(false);
          setBioChanged(false);
          setGenreChanged(false);
          setRankingChanged(false);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          oneRingRulesAll("logout");
        }
        setCKPopupType("Warning");
        setCKPopupMessage("somethingWrong");
        setCKPopup(true);
        setRequestSent(false);
      });
  };

  const rankings = [
    { title: "МУСТА", rank: "МУСТА", id: 1 },
    { title: "МУГЖ", rank: "МУГЖ", id: 2 },
    { title: "МУГБ", rank: "МУГБ", id: 3 },
    { title: "МУУГЗ", rank: "МУУГЗ", id: 4 },
    { title: "Төрийн шагналт", rank: "Төрийн шагналт", id: 5 },
    { title: "Төрийн соёрхолт", rank: "Төрийн соёрхолт", id: 6 },
    { title: "Чингис хааны одонт", rank: "Чингис хааны одонт", id: 7 },
    { title: "Хоосон", rank: "", id: 8 },
  ];

  const genreRemoveHandler = (id) => {
    const index = secondaryGenres.findIndex((object) => {
      return object.id === id;
    });
    if (index > -1) {
      secondaryGenres.splice(index, 1);
    }
    setDummy(!dummy);
  };
  const secondaryGenresMapped = secondaryGenres.map((genre) => {
    return (
      <div
        className="genres"
        onClick={() => {
          genreRemoveHandler(genre.id);
        }}
        key={genre?.id}
      >
        <h5 className="text-xs font-medium truncate">{genre?.name}</h5>

        <IconController src={assets.svg.genreKill} className="w-4 h-4" />
      </div>
    );
  });
  const nameChangeHandler = (e) => {
    setNameField(e.target.value);
    setNameChanged(true);
  };
  const bioChangeHandler = (e) => {
    setBioField(e.target.value);
    setBioChanged(true);
  };
  return (
    <Wrapper className="box p-4 md:p-6 w-full">
      {editable ? (
        <>
          {requestSent ? (
            <div
              className="absolute bottom-0 left-0 w-full h-full rounded-xl"
              style={{ background: "#a9b7d280", zIndex: "1001" }}
            >
              <div className="w-full h-full flex flex-row justify-center items-center">
                <LottieController
                  src={assets.lottie.loadingLottie}
                  className="w-32 h-32 flex flex-row justify-center"
                />
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="flex flex-col gap-6 pt-12 md:pt-10">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-0">
              <ImgController
                src={data?.cover}
                className="h-24 w-24 flex-shrink-0"
                imgClassName="rounded-full"
              />
              <div className="flex flex-col sm:pl-3 input-wrapper">
                <div className="relative">
                  <div
                    className="ranking-dropdown"
                    onClick={() => {
                      setRankingPopup(true);
                    }}
                  >
                    <h5 className="flex-1 color-grey text-xs font-semibold">
                      {selectedRank === null ? "Хоосон" : selectedRank}
                    </h5>
                    <IconController
                      src={assets.svg.chevronDown}
                      className="w-4 h-4"
                    />
                  </div>
                  {rankingPopup ? (
                    <>
                      <Overlay
                        onClick={() => {
                          setRankingPopup(false);
                        }}
                      />
                      <PopupRanking>
                        <div className="modal-ranking">
                          <div className="flex flex-col h-full pt-4">
                            <div className="flex flex-col gap-4 overflow-scroll result-list px-4 pb-4">
                              {rankings.map((rank) => {
                                return (
                                  <Rankings
                                    rank={rank}
                                    selectedRank={selectedRank}
                                    setSelectedRank={setSelectedRank}
                                    key={rank.id}
                                    setRankingChanged={setRankingChanged}
                                  />
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </PopupRanking>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    className="name-input"
                    placeholder={data.name}
                    onChange={(e) => {
                      nameChangeHandler(e);
                    }}
                  />
                </div>
                <div className="flex flex-row flex-wrap gap-3">
                  <div className="relative">
                    <div className="genre-dropdown">
                      <div className="flex flex-row gap-3 flex-1 ">
                        <div
                          className="genres"
                          onClick={() => {
                            setPrimaryGenrePopup(true);
                          }}
                        >
                          <IconController
                            src={assets.svg.genreCrownWhite}
                            className="w-4 h-4"
                          />
                          <h5 className="text-xs font-medium truncate">
                            {primaryGenre?.name}
                          </h5>
                        </div>
                      </div>
                      {primaryGenrePopup ? (
                        <div
                          onClick={() => {
                            setPrimaryGenrePopup(true);
                          }}
                          className="pl-2"
                        >
                          <IconController
                            src={assets.svg.chevronDown}
                            className="w-4 h-4 rotate-180"
                          />
                        </div>
                      ) : (
                        <div
                          onClick={() => {
                            setPrimaryGenrePopup(true);
                          }}
                          className="pl-2"
                        >
                          <IconController
                            src={assets.svg.chevronDown}
                            className="w-4 h-4"
                          />
                        </div>
                      )}
                    </div>
                    {primaryGenrePopup ? (
                      <>
                        <Overlay
                          onClick={() => {
                            setPrimaryGenrePopup(false);
                          }}
                        />
                        <PopupGenre>
                          <div className="modal-genre">
                            <div className="flex flex-col h-full pt-2">
                              <div className="flex flex-col gap-2 overflow-scroll result-list pb-2">
                                {genres.map((genre) => {
                                  return (
                                    <SelectPrimaryGenre
                                      genreInformation={genre}
                                      key={genre.id}
                                      primaryGenre={primaryGenre}
                                      setPrimaryGenre={setPrimaryGenre}
                                      secondaryGenres={secondaryGenres}
                                      setGenreChanged={setGenreChanged}
                                    />
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </PopupGenre>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="relative">
                    <div className="genre-dropdown">
                      <div className="flex flex-row gap-3 flex-1 items-center flex-wrap">
                        {secondaryGenres.length === 0 ? (
                          <>
                            <h5
                              className="text-xs font-medium"
                              onClick={() => {
                                setSecondaryGenresPopup(true);
                              }}
                            >
                              Нэмэлт жанр сонгох
                            </h5>{" "}
                            &nbsp;
                          </>
                        ) : (
                          secondaryGenresMapped
                        )}
                      </div>

                      {secondaryGenresPopup ? (
                        <div
                          onClick={() => {
                            setSecondaryGenresPopup(false);
                          }}
                          className="pl-2"
                        >
                          <IconController
                            src={assets.svg.chevronDown}
                            className="w-4 h-4 rotate-180"
                          />
                        </div>
                      ) : (
                        <div
                          onClick={() => {
                            setSecondaryGenresPopup(true);
                          }}
                          className="pl-2"
                        >
                          <IconController
                            src={assets.svg.chevronDown}
                            className="w-4 h-4"
                          />
                        </div>
                      )}
                    </div>
                    {secondaryGenresPopup ? (
                      <>
                        <Overlay
                          onClick={() => {
                            setSecondaryGenresPopup(false);
                          }}
                        />
                        <PopupGenre>
                          <div className="modal-genre">
                            <div className="flex flex-col h-full pt-4">
                              <div className="flex flex-col gap-4 overflow-scroll result-list px-4 pb-4">
                                {genres.map((genre) => {
                                  return (
                                    <SelectSecondaryGenres
                                      setGenreChanged={setGenreChanged}
                                      genreInformation={genre}
                                      key={genre.id}
                                      secondaryGenres={secondaryGenres}
                                      primaryGenre={primaryGenre}
                                    />
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </PopupGenre>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <textarea
                className="bio-input text-xs"
                placeholder={data.bio}
                rows="5"
                onChange={(e) => {
                  bioChangeHandler(e);
                }}
              />
            </div>
            <div className="absolute top-4 right-4 ">
              <div className="flex flex-row gap-2">
                <div className="cancel-button">
                  <Ripples
                    color="#0061ff40"
                    during={600}
                    className="rounded-2xl"
                  >
                    <div
                      className="flex flex-row justify-center items-center px-3"
                      onClick={() => {
                        setEditable(false);
                      }}
                    >
                      <div className="flex flex-row justify-center items-center">
                        <h5 className="text-xs font-medium py-2 pr-1">Болих</h5>
                        <IconController
                          src={assets.svg.cancelIcon}
                          className="h-4 w-4"
                        />
                      </div>
                    </div>
                  </Ripples>
                </div>
                <div className="confirm-button">
                  <Ripples
                    color="#ffffff40"
                    during={600}
                    className="rounded-2xl"
                  >
                    <div
                      className="flex flex-row justify-center items-center px-3"
                      onClick={() => {
                        mailAttributes.length = 0;
                        if (
                          !rankingChanged &&
                          !nameChanged &&
                          !genreChanged &&
                          !bioChanged
                        ) {
                          setCKPopupType("Info");
                          setCKPopupMessage("nothingChanged");
                          setCKPopup(true);
                        } else {
                          if (rankingChanged) {
                            mailAttributes.push({
                              field: "Цол",
                              value: {
                                old: data.profile.ranking,
                                new: selectedRank,
                              },
                            });
                          }
                          if (nameChanged) {
                            mailAttributes.push({
                              field: "Нэр",
                              value: {
                                old: data.name,
                                new: nameField,
                              },
                            });
                          }
                          if (genreChanged) {
                            mailAttributes.push(
                              {
                                field: "Үндсэн Жанр",
                                value: {
                                  old: data.primary_genre.name,
                                  new: primaryGenre.name,
                                },
                              },
                              {
                                field: "Бусад Жанр",
                                value: {
                                  old: SGFirst,
                                  new: secondaryGenres
                                    .map((b) => {
                                      return b.name;
                                    })
                                    .join(", "),
                                },
                              }
                            );
                          }
                          if (bioChanged) {
                            mailAttributes.push({
                              field: "Тайлбар",
                              value: {
                                old: data.bio,
                                new: bioField,
                              },
                            });
                          }
                          setConfirmation(true);
                        }
                      }}
                    >
                      <h5 className="text-xs font-medium py-2 pr-1">
                        Өөрчлөх хүсэлт илгээх
                      </h5>
                      <IconController
                        src={assets.svg.requestMail}
                        className="h-4 w-4"
                      />
                    </div>
                  </Ripples>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="flex flex-col gap-6 pt-10 md:pt-0">
          <div className="flex flex-row">
            <ImgController
              src={data?.cover}
              className="h-16 w-16 md:h-24 md:w-24 flex-shrink-0"
              imgClassName="rounded-full"
            />
            <div className="flex flex-col pl-3 min-w-0">
              <h5 className="text-xs">{data?.profile?.ranking} &nbsp;</h5>
              <h5 className="font-bold text-base pt-1 pb-3 break-words">{data?.name}</h5>
              <div className="flex flex-row items-center gap-1">
                <div className="flex flex-row flex-wrap items-center gap-x-3 gap-y-1">
                  {data?.primary_genre !== null ? (
                    <div className="flex flex-row gap-1">
                      <IconController src={assets.svg.genreCrown} />
                      <h5 className="text-xs font-bold text-mmusic">
                        {data?.primary_genre?.name}
                      </h5>
                    </div>
                  ) : (
                    ""
                  )}
                  {data?.secondary_genres.length !== 0
                    ? secondaryGenres.map((genre) => {
                        return (
                          <div key={genre.id} className="flex flex-row gap-3">
                            <span className="text-xs font-bold text-mmusic">
                              /
                            </span>
                            <h5 className="text-xs font-bold text-mmusic opacity-50  ">
                              {genre.name}
                            </h5>
                          </div>
                        );
                      })
                    : ""}
                </div>
              </div>
            </div>
          </div>
          <div>
            <h5 className="text-xs">{data?.bio}</h5>
          </div>
          {isUserCanEdit ? (
            <div className="edit-button">
              <Ripples color="#0061ff40" during={600} className="rounded-2xl">
                <div
                  className="flex flex-row justify-center items-center px-3"
                  onClick={() => {
                    setEditable(true);
                  }}
                >
                  <h5 className="text-xs font-medium py-2 pr-1">Засах</h5>
                  <IconController
                    src={assets.svg.editIcon}
                    className="h-4 w-4"
                  />
                </div>
              </Ripples>
            </div>
          ) : (
            ""
          )}
        </div>
      )}
      {confirmation ? (
        <HttpConfirmation
          yesFunc={requestHandler}
          data={mailData}
          noFunc={setConfirmation}
        />
      ) : (
        ""
      )}
    </Wrapper>
  );
};

export default ArtistCard;
